import Query from '../Query';
import { filterData } from './filter.js'; 
import { dataFiltered } from './data.js';

export const screenResize = () => ({
  type: 'SCREEN_RESIZE'
})

export const calculatingData = () => ({
  type: 'SHOW_LOADING'
})

//export const getData = (text) => ({
//  type: 'GET_DATA',
//  text
//})

export const receiveData = (data) => ({
  type: 'RECEIVE_DATA',
  data: data
})

export const receiveOverlays = (data) => ({
  type: 'RECEIVE_OVERLAYS',
  data: data
})

export const receiveFilters = (data) => ({
  type: 'RECEIVE_FILTERS',
  data: data
})

export const setBusyText = (text) => ({
  type: 'SET_BUSY_TEXT',
  text
})

export const fetchData = () => dispatch => {
  console.log("FETCHING DATA");
  dispatch(setBusyText("Loading data."))
  //dispatch(getData())
  dispatch({type: "LOSE_LOCATION"});
  return Query.search('/api/data').then( (data) => {
    if(data instanceof Error || !data.success) {
      dispatch({ type: 'ERROR', message: 'Could not retrieve records from the database.'})
    } else {
      if(data.success){
        dispatch(receiveData(data))
        dispatch(filterData())
        dispatch(dataFiltered())
      } else {
        console.log(data.error)
        dispatch({ type: 'ERROR', message: "Error: " + data.error})
      }
    }
  }).catch(error => {
    console.log(error)
    dispatch({ type: 'ERROR', message: 'Error processing data.'})
  })
}

export const fetchOverlays = () => dispatch => {
  return Query.search('/api/overlays').then( (data) => {
    if(data instanceof Error) {
      dispatch({ type: 'ERROR', message: 'There was an error fetching the map overlays from the server.'})
    } else {
      var layers = [];
      data.layers.forEach(function(x) {
        layers.push(JSON.parse(x));
      })
      dispatch(receiveOverlays(layers))
    }
  }).catch(error => {
    console.log(error)
    dispatch({ type: 'ERROR', message: 'Error processing map overlays.'})
  });
}

export const fetchFilters = () => dispatch => {
  return Query.search('/api/filters').then( (data) => {
    if(data instanceof Error) {
      dispatch({ type: 'ERROR', message: 'There was an error fetching the filter options from the server.'})
    } else {
      dispatch(receiveFilters(data))
    }
  }).catch(error => {
    console.log(error)
    dispatch({ type: 'ERROR', message: 'Error processing map overlays.'})
  });
}

export const showLoading = () => ({
  type: 'SHOW_LOADING'
})

export const hideLoading = () => ({
  type: 'HIDE_LOADING'
})

export const clearErrorMessage = () => ({
  type: "CLEAR_ERROR_MESSAGE"
})



// WEBPACK FOOTER //
// ./src/actions/index.js